import { render, staticRenderFns } from "./RequestV2.vue?vue&type=template&id=175bc206&"
import script from "./RequestV2.vue?vue&type=script&lang=js&"
export * from "./RequestV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports